import { Visitable } from './Visitable';
import { Visitor } from './Visitor';
import moment from 'moment-timezone';

import { RequestBooking } from '../types/BookingTypes';
import Links = RequestBooking.Links;
import {isNullOrUndefined} from "../utils";

type Moment = moment.Moment;

interface Plan {
    dayOfWeek: Array<string>;
    servers: Array<string>;
    startDate: Moment;
    timeTable: Array<string>;
}

export interface CombinedTime {
    time: string;
    original: string;
}

export interface AvailableDate {
    date: string;
    times: Array<CombinedTime>;
}

export default class BookingCalendar implements Visitable {
    private _availableDates?: Array<string>;
    private _plans?: Array<Plan>;
    private _availability?: object;
    private _links?: Links;

    accept(visitor: Visitor): void {
        throw new Error('Unimplemented method');
    }

    get availableDates(): Array<string> {
        return this._availableDates ?? [];
    }

    set availableDates(dates: Array<string>) {
        this._availableDates = dates;
        this._availability = {};

        dates.forEach((momentDate) => {
            const convertedDate = moment(momentDate).tz('Europe/Rome');
            const indexDate = convertedDate.format('YYYY-MM-DD');
            const time = convertedDate.format('HH:mm:ss');
            let obj: AvailableDate = (this.availability as any)[indexDate];
            if (isNullOrUndefined(obj)) {
                obj = {date: indexDate, original: momentDate, times: []} as AvailableDate;
            }
            let complexTime = {time: time, original: momentDate} as CombinedTime;
            obj.times.push(complexTime);
            (this._availability as any)[indexDate] = obj;
        });
    }

    set links(links: Links) {
        this._links = links;
    }

    get links() {
        return this._links ?? {} as Links;
    }

    /*
    set availableDates(dates: Array<AvailableDate>) {
        this._availableDates = dates;
        this._availability = {};
        console.log('DATES----------------------------------------');
        console.log(dates);
        console.log('---------------------------------------------');

        const converted = new Array<string>();

        dates.forEach((date) => {
           date.times.forEach((time) => {
               const complete = date.date + 'T' + time;
               converted.push(moment(complete).tz('Europe/Rome').format());
           });
        });

        converted.forEach((momentDate) => {
            const convertedDate = moment(momentDate);
            const indexDate = convertedDate.format('YYYY-MM-DD');
            const time = convertedDate.format('HH:mm:ss');
            let obj: AvailableDate = this.availability[indexDate];
            if (isNullOrUndefined(obj)) {
                obj = {date: indexDate, times: []} as AvailableDate;
            }
            obj.times.push(time);
            this._availability[indexDate] = obj;
        });
    }
*/
    get availability(): object  {
        return this._availability ?? {};
    }

    get plans(): Array<Plan> {
        return this._plans ?? [];
    }

    set plans(plans: Array<Plan>) {
        this._plans = plans;
    }
}